import type { WhiteLabel } from '@skytech/types'

type StatusInStock = 'success' | 'warning' | 'error'
// inStock element styles
export const bgColorClassByWhiteLabel: Partial<Record<WhiteLabel, Record<StatusInStock, string>>> =
  {
    skytech: {
      success: 'bg-green-badge',
      warning: 'bg-[#f1c40f]',
      error: 'bg-red',
    },
    threeStepIT: {
      success: 'bg-threeStepIT-success',
      warning: 'bg-threeStepIT-warning',
      error: 'bg-threeStepIT-failure',
    },
  }
